export const enum UserPermission {
    Geolocation = 'geolocation',
}
